import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';

const useValidationSchema = () => {
  const { required } = useValidators();

  const TenantFormSchema = yup.object().shape({
    tenant: required(yup.string()),
  });

  return { TenantFormSchema };
};

export default useValidationSchema;
